import { RootState, Status, Tip } from '../types';

export const getTipsStatus = (state: RootState): Status => state.tips.status;

export const getTipsErrorMsg = (state: RootState): string | null => state.tips.errorMsg;

export const getTips = (state: RootState): Tip[] => state.tips.tips;
